__turbopack_context__.v({
  "hidePaginator": "styles-module-scss-module__s5fbYq__hidePaginator",
  "itemContainer": "styles-module-scss-module__s5fbYq__itemContainer",
  "noData": "styles-module-scss-module__s5fbYq__noData",
  "pagination": "styles-module-scss-module__s5fbYq__pagination",
  "periodSelectSpinner": "styles-module-scss-module__s5fbYq__periodSelectSpinner",
  "title": "styles-module-scss-module__s5fbYq__title",
  "topParentsContainer": "styles-module-scss-module__s5fbYq__topParentsContainer",
  "topParentsHeader": "styles-module-scss-module__s5fbYq__topParentsHeader",
  "topParentsPanelGroupItem": "styles-module-scss-module__s5fbYq__topParentsPanelGroupItem",
});
